export const environment = {  production: true,  serviceBaseUrl: 'https://balancer.frxrcprod.net/FRX-LWR',};
